var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createPaymentOrder, updatePaymentOrder, } from "../../redux/payment/payment.actions";
import * as paymentOrderActions from "../../reduxV2/paymentOrder/paymentOrder.actions";
import { getAdditionalCostPaymentOrder, getAdditionalCostPaymentOrderV2, getCommissionPaymentOrder, getCommissionPaymentOrderV2, getCommonCostsPaymentOrder, getCommonCostsPaymentOrderV2, getManagementFeePaymentOrder, getManagementFeePaymentOrderV2, getNonCommonCostsPaymentOrder, getNonCommonCostsPaymentOrderV2, getPaymentGroup, getPaymentOrder, getPaymentOrderV2, } from "./schema.createPayment.actions.utils";
import { EField, } from "./schema.createPayment.types";
import { getRelatedContract } from "./schema.createPayment.utils";
export var isPerformingSubmitActionSelector = function (paymentOrder, useV2Payments) {
    return function (state) {
        var _a, _b;
        if (paymentOrder) {
            var updateStateUpdating = useV2Payments
                ? (_a = state.PAYMENT_ORDERS_V2.update[paymentOrder.id]) === null || _a === void 0 ? void 0 : _a.pending
                : (_b = state.payment.updatePaymentOrders[paymentOrder.id]) === null || _b === void 0 ? void 0 : _b.isUpdatingPaymentOrder;
            if (updateStateUpdating) {
                return updateStateUpdating;
            }
            return false;
        }
        return useV2Payments
            ? state.PAYMENT_ORDERS_V2.createPaymentOrders.pending || false
            : !!state.payment.isCreatingPaymentOrder;
    };
};
export var performingSubmitActionErrorSelector = function (paymentOrder, useV2Payments) {
    return function (state) {
        var _a, _b;
        if (paymentOrder) {
            var updateStateError = useV2Payments
                ? (_a = state.PAYMENT_ORDERS_V2.update[paymentOrder.id]) === null || _a === void 0 ? void 0 : _a.error
                : (_b = state.payment.updatePaymentOrders[paymentOrder.id]) === null || _b === void 0 ? void 0 : _b.fetchPaymentOrdersError;
            if (updateStateError) {
                return updateStateError;
            }
            return;
        }
        return useV2Payments
            ? state.PAYMENT_ORDERS_V2.createPaymentOrders.error
            : state.payment.createPaymentOrderError;
    };
};
export var submitActionCreator = function (extraData, propertyId, paymentOrderId, paymentOrder, useV2Payments) {
    return function (formData) {
        var _a, _b;
        var contract = getRelatedContract(extraData, formData);
        var contractId = contract === null || contract === void 0 ? void 0 : contract.id;
        if (paymentOrderId) {
            if (useV2Payments) {
                var updatedPaymentOrderV2 = getPaymentOrderV2(formData, extraData);
                var paymentGroupDto = getPaymentGroup(formData, propertyId, extraData);
                return paymentOrderActions.updateStart.getAction({
                    id: paymentOrderId,
                    data: __assign(__assign({}, updatedPaymentOrderV2), { paymentGroupDto: paymentGroupDto }),
                });
            }
            var updatedPaymentOrder = getPaymentOrder(formData, propertyId, extraData);
            return updatePaymentOrder.actions.start({
                paymentOrderId: paymentOrderId,
                paymentOrder: updatedPaymentOrder,
            });
        }
        if (useV2Payments) {
            var paymentOrders_1 = [];
            var mainPaymentOrder_1 = getPaymentOrderV2(formData, extraData);
            paymentOrders_1.push(mainPaymentOrder_1);
            var commonCostsPaymentOrder_1 = getCommonCostsPaymentOrderV2(formData, contract);
            if (commonCostsPaymentOrder_1) {
                paymentOrders_1.push(commonCostsPaymentOrder_1);
            }
            var nonCommonCostsPaymentOrder_1 = getNonCommonCostsPaymentOrderV2(formData, contract);
            if (nonCommonCostsPaymentOrder_1) {
                paymentOrders_1.push(nonCommonCostsPaymentOrder_1);
            }
            var commissionPaymentOrder_1 = getCommissionPaymentOrderV2(formData, contract);
            if (commissionPaymentOrder_1) {
                paymentOrders_1.push(commissionPaymentOrder_1);
            }
            var managementFeePaymentOrder_1 = getManagementFeePaymentOrderV2(formData, contract);
            if (managementFeePaymentOrder_1) {
                paymentOrders_1.push(managementFeePaymentOrder_1);
            }
            if (((_a = formData === null || formData === void 0 ? void 0 : formData.additionalCostsArray) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                formData === null || formData === void 0 ? void 0 : formData.additionalCostsArray.forEach(function (cost) {
                    var bookkeepingSettings = formData.additionalCostBookkeepingArray.find(function (settings) {
                        return settings.id === cost.id;
                    });
                    var additionalCostPaymentOrder = getAdditionalCostPaymentOrderV2({
                        formData: formData,
                        costInfo: cost,
                        bookkeepingInfo: bookkeepingSettings,
                        contract: contract,
                        extraData: extraData,
                    });
                    paymentOrders_1.push(additionalCostPaymentOrder);
                });
            }
            var paymentGroup = getPaymentGroup(formData, propertyId, extraData);
            return paymentOrderActions.createPaymentOrdersStart.getAction({
                data: { paymentOrders: paymentOrders_1, paymentGroup: paymentGroup },
                document: formData[EField.Document] || undefined,
                contractId: formData[EField.LinkToContract] === "yes" ? contract === null || contract === void 0 ? void 0 : contract.id : undefined,
                documentCategory: formData[EField.DocumentCategory] || undefined,
            });
        }
        var paymentOrders = [];
        var mainPaymentOrder = getPaymentOrder(formData, propertyId, extraData);
        paymentOrders.push(mainPaymentOrder);
        var commonCostsPaymentOrder = getCommonCostsPaymentOrder(formData, propertyId, contractId, contract);
        if (commonCostsPaymentOrder) {
            paymentOrders.push(commonCostsPaymentOrder);
        }
        var nonCommonCostsPaymentOrder = getNonCommonCostsPaymentOrder(formData, propertyId, contractId, contract);
        if (nonCommonCostsPaymentOrder) {
            paymentOrders.push(nonCommonCostsPaymentOrder);
        }
        var commissionPaymentOrder = getCommissionPaymentOrder(formData, propertyId, contractId, contract);
        if (commissionPaymentOrder) {
            paymentOrders.push(commissionPaymentOrder);
        }
        var managementFeePaymentOrder = getManagementFeePaymentOrder(formData, propertyId, contractId, contract);
        if (managementFeePaymentOrder) {
            paymentOrders.push(managementFeePaymentOrder);
        }
        if (((_b = formData === null || formData === void 0 ? void 0 : formData.additionalCostsArray) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            formData === null || formData === void 0 ? void 0 : formData.additionalCostsArray.forEach(function (cost) {
                var bookkeepingSettings = formData.additionalCostBookkeepingArray.find(function (settings) {
                    return settings.id === cost.id;
                });
                var additionalCostPaymentOrder = getAdditionalCostPaymentOrder({
                    formData: formData,
                    extraData: extraData,
                    costInfo: cost,
                    bookkeepingInfo: bookkeepingSettings,
                    propertyId: propertyId,
                    contract: contract,
                });
                paymentOrders.push(additionalCostPaymentOrder);
            });
        }
        return createPaymentOrder.actions.start({
            paymentOrders: paymentOrders,
            document: formData[EField.Document] || undefined,
            contractId: formData[EField.LinkToContract] === "yes" ? contract === null || contract === void 0 ? void 0 : contract.id : undefined,
            propertyId: propertyId,
            documentCategory: formData[EField.DocumentCategory] || undefined,
        });
    };
};
